import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-chatcentered",
  "use": "icon-th-chatcentered-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-chatcentered\">\n<path d=\"M27 5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V23C3 23.5304 3.21071 24.0391 3.58579 24.4142C3.96086 24.7893 4.46957 25 5 25H12.4338L14.285 28.0287C14.4623 28.3244 14.713 28.5693 15.0127 28.7396C15.3125 28.9098 15.6512 28.9997 15.996 29.0004C16.3408 29.0012 16.6799 28.9128 16.9804 28.7439C17.2809 28.5749 17.5327 28.3312 17.7113 28.0362L19.5662 25H27C27.5304 25 28.0391 24.7893 28.4142 24.4142C28.7893 24.0391 29 23.5304 29 23V7C29 6.46957 28.7893 5.96086 28.4142 5.58579C28.0391 5.21071 27.5304 5 27 5ZM27 23H19.5662C19.2224 23.0007 18.8844 23.0897 18.5848 23.2585C18.2852 23.4272 18.0339 23.6701 17.855 23.9638L16 27L14.1438 23.9625C13.9647 23.6693 13.7135 23.4269 13.4142 23.2584C13.1148 23.0899 12.7773 23.0009 12.4338 23H5V7H27V23Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-chatcentered.svg
// module id = 7nks
// module chunks = 83